import { render, staticRenderFns } from "./FeedbackModule.vue?vue&type=template&id=6589989e&scoped=true"
import script from "./FeedbackModule.vue?vue&type=script&lang=js"
export * from "./FeedbackModule.vue?vue&type=script&lang=js"
import style0 from "./FeedbackModule.vue?vue&type=style&index=0&id=6589989e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6589989e",
  null
  
)

export default component.exports